<template>
  <div>
    <Headersys ref="Headersys" />
    <div class="content">
      <!-- 头 -->
      <BsznCurrent :steps="2" :type="2" />
      <div class="section-box">
        <div class="realy-content">
          <div class="section-code-box">
            <div>
              <canvas id="qrCode"></canvas>
              <div class="qr-tips">手机扫描二维码</div>
              <div class="qr-tips">查看办事指南</div>
            </div>
          </div>
          <div class="section-content-box">
            <div class="side-box">
              <div class="side-title">
                事项名称
              </div>
              <div class="side-item">
                {{ details.NAME }}
              </div>
            </div>
            <!-- 111 -->
            <div class="side-box">
              <div class="side-title">
                实施主体
              </div>
              <div class="side-item">
                {{ details.ORG_NAME }}
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">
                受理条件
              </div>
              <div class="side-item">
                <div v-for="(item, idx) in conditionList" :key="idx">{{ idx + 1 }}.{{ item.NAME }}</div>
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">
                申请材料
              </div>
              <div class="side-item" v-for="(item, idx) in materialList" :key="idx">
                {{ idx + 1 }}.{{ item.NAME }}<span class="red must" v-if="item.MUST == '1'">(必要)</span><span v-else
                  class="must">(非必要)</span>
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">
                法定时限
              </div>
              <div class="side-item">
                {{ details.LAW_TIME }}个工作日
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">
                承诺时限
              </div>
              <div class="side-item">
                {{ details.AGREE_TIME }}个工作日
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">
                受理地点
              </div>
              <div class="side-item">
                {{ details.ADDRESS }}
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">
                受理时间
              </div>
              <div class="side-item">
                {{ details.OFFICE_HOUR }}
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">
                咨询电话
              </div>
              <div class="side-item">
                {{ consultInfo.CONSULTINGPHONE }}
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">
                投诉电话
              </div>
              <div class="side-item">
                {{ consultInfo.COMPLAINTSHOTLINE }}
              </div>
            </div>
            <div class="side-box">
              <div class="side-title">
                是否收费
              </div>
              <div class="side-item">
                <div v-if="details.IS_CHARGE == '0'">不收费</div>
                <div v-else>收费</div>
              </div>
            </div>
            <div style="height: 10rem;"></div>
          </div>
        </div>
      </div>
      <Back :print="printType" @toSubmit="toSubmit" />
      <div class="load-mask" id="loadDom" v-if="maskShow">
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode";
import { Loading } from "element-ui";
import { v4 as uuidv4 } from "uuid";

export default {
  name: '',
  data() {
    return {
      //
      details: {},//详情
      materialList: [],//申请材料
      conditionList: [],//受理条件
      consultInfo: {},//咨询投诉
      code: '',
      loadingInstance: null,
      waitTime: 280,
      watiTimer: null,
      today: '',
      maskShow: false,
      fmac: "",
      phone: "",
      name: "",
      idCard: "",
      uuid: '',
      printType: '3'
    };
  },
  created() {
    this.code = this.$route.query.code
    this.getDetails()
    this.getSLTJ()
    this.getConsult()
    this.today = this.$fun.getTime(new Date())
  },
  mounted() {
    //
    this.useqrcode()
    // this.timeDown()
    this.$fun.getMAC(mac => {
      this.fmac = mac;
      var userInfo = this.$store.state.suerInfo
      this.name = userInfo.name;
      this.phone = userInfo.tel;
      this.idCard = userInfo.cerno;
      this.$rqt.print_saveClickRecord({
        fname: this.name,
        fcerno: this.idCard,
        phone: this.phone,
        fmac: this.fmac,
        fitemid: this.code,
        fitem: this.details.NAME,
      });
    })
  },
  destroyed() {
    clearTimeout(this.watiTimer);
  },
  methods: {
    // 提交
    toSubmit() {
      console.log('提价');
      var data = {
        fileUrls: this.materialList,
        masterId: "",//事项id
        masterName: this.details.NAME,//事项名称
        regionCode: "370724000000",
        // state: "",
        tenantName: this.details.ORG_NAME,
        uploadCode: ""
      }
      this.$rqt.busUpload_submit(data).then(res => {
        console.log(res);

      })
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--
        } else {
          this.waitTime = 280
          clearInterval(this.watiTimer)
          this.$router.replace('/')
        }
      }, 1000);
    },
    //获取事项详情
    getDetails() {
      this.$rqt.division_sendUr2({
        url: 'getItemInfoByItemCode',
        params: {
          // regionCode: '370705000000',
          itemCode: this.code,
          infoType: "info"
        }
      }).then(res => {
        this.details = JSON.parse(res.data).ItemInfo[0]
      })
    },
    // 申请材料
    getShenCL() {
      this.$rqt.division_sendUr2({
        url: 'getItemInfoByItemCode',
        params: {
          itemCode: this.code,
          infoType: "material"
        }
      }).then(res => {
        // console.log('申请材料', JSON.parse(res.data));
        // this.materialList = JSON.parse(res.data).ItemInfo
        var arr = JSON.parse(res.data).ItemInfo
        arr.forEach(el => {
          this.materialList.push({
            NAME: el.NAME,
            MUST: el.MUST,
            fileList: []
          })
        });
        this.$rqt.common_saveRecord({
          key: this.uuid,
          value: this.materialList
        })
      })
    },
    // 受理条件
    getSLTJ() {
      this.$rqt.division_sendUr2({
        url: 'getItemInfoByItemCode',
        params: {
          itemCode: this.code,
          infoType: "condition"
        }
      }).then(res => {
        // console.log('受理条件',JSON.parse(res.data));
        this.conditionList = JSON.parse(res.data).ItemInfo
      })
    },
    // 咨询投诉
    getConsult() {
      this.$rqt.division_sendUr2({
        url: 'getItemInfoByItemCode',
        params: {
          regionCode: '370705000000',
          itemCode: this.code,
          infoType: "consult"
        }
      }).then(res => {
        // console.log('咨询投诉', JSON.parse(res.data));
        this.consultInfo = JSON.parse(res.data).ItemInfo[0]
      })
    },
    useqrcode() {
      this.uuid = uuidv4().replaceAll("-", "");
      // this.uuid = '10086'
      this.getShenCL()
      var canvas = document.getElementById("qrCode");
      // 调用函数去生成二维码，参数依次为：二维码的容器、要生成的内容、回调函数   http://192.168.1.104:8080
      QRCode.toCanvas(
        canvas,
        `http://192.168.1.104:8080/#/sxsbFile?id=${this.uuid}`,
        // `https://l.zwfwpt.cn/#/sxsbFile?id=${this.uuid}`,
        function (error) {
          if (error) {
            console.error(error);
          }
        }
      );
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem);
  padding: 0 5rem;
  background-color: #F1FAFC;
  position: relative;
}

.load-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  // background-color: red;
}

.section-box {
  // display: flex;
  // align-items: center;
  // background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 2rem;
  position: relative;

  .realy-content {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 2rem;
  }

  .section-code-box {
    width: 20%;
    height: calc(100vh - 93rem);
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid rgba($color: #000000, $alpha: .1);

    .qr-tips {
      text-align: center;
      font-weight: bold;
      margin-bottom: 3rem;
      font-size: 5rem;
    }
  }

  .section-content-box {
    width: 80%;
    height: calc(100vh - 93rem);
    overflow-y: scroll;

    .side-box {
      width: 95%;
      margin: auto;
      padding: 4rem 0 5rem;
      border-bottom: 2px solid #DFDCDF;

      .side-title {
        font-size: 5rem;
        font-weight: bold;
        color: #55A5FF;
        margin-bottom: 3rem;
      }

      .side-item {
        font-size: 4rem;
      }
    }
  }

  .section-content-box::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
}

#qrCode {
  width: 30rem !important;
  height: 30rem !important;
  display: block;
  margin: 0 auto 5rem;
}

.must {
  margin-left: 3rem;
}

.red {
  color: #ff0000;
}

.table {
  position: fixed;
  top: 999rem;
  left: 999rem;
}
</style>